module.exports = __webpack_public_path__ + "static/img/101208.9c26db23.png";